import { render } from "./TermsAndConditionsView.vue?vue&type=template&id=97941a02&scoped=true"
import script from "./TermsAndConditionsView.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsView.vue?vue&type=script&lang=js"

import "./TermsAndConditionsView.vue?vue&type=style&index=0&id=97941a02&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97941a02"]])

export default __exports__